<template>
	<el-dialog title="门店出库记录" :visible.sync="visible" :before-close='recordStateClose' width="1200px">
		<el-table :data="record" style="width: 100%">
			<el-table-column type="index" />
			<el-table-column prop="distribution_no" label="分拨单号" :key="1"/>
			<el-table-column prop="company_info.shop_name" label="分拨门店" align="center" :key="2"/>
			<el-table-column prop="count" label="分拨数量" align="center" :key="3"/>
			<el-table-column prop="create_time" label="分拨时间" align="center" :key="4">
				<template slot-scope="scope">
					<span>{{FormatDate(scope.row.create_time)}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="add_user.user_name" label="操作人" align="center" :key="5"/>
			<el-table-column label="操作" width="200" align="center" :key="6">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="downloadClick(scope.row)">下载分拨单</el-button>
					<el-button type="text" size="small" @click="downCWClick(scope.row)">下载财务单</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="recordStateClose">确 定</el-button>
		</span> -->
	</el-dialog>
</template>
<script>
	import axios from 'axios';
	export default {
		props: {
			recordState: { //显示状态
				default: false
			},
			recordData: {
				default: {}
			},
			id: {
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				record: [], //分拨出库记录
			};
		},
		watch: {
			// 监视状态发生改变
			recordState() {
				this.visible = this.recordState;
			},
		},
		created() {
			// console.log(this.recordData.procure_distributions)
			this.record = [...this.recordData.procure_distributions];
			console.log(this.record)
		},
		methods: {
			//向父组件发射关闭弹框
			recordStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			//重构日期
			FormatDate(item) {
				let time = new Date(item * 1000)
				let year = time.getFullYear()
				let month = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
				let date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
				return year + '-' + month + '-' + date
			},
			//下载分拨单
			downloadClick(row) {
				console.log(row)
				axios.get(process.env.VUE_APP_caigou+'api/Procure/UpLoadDistribution',{
					params:{
						id:this.id,
						distribution_no: row.distribution_no
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '分拨单导出.docx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
			//下载财务单
			downCWClick(row) {
				console.log(row)
				axios.get(process.env.VUE_APP_caigou+'api/Procure/UpLoadDistributionCaiWu',{
					params:{
						id:this.id,
						distribution_no: row.distribution_no
					},
					responseType: 'blob'
				}).then(response => {
					// console.log(response)
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '财务单导出.docx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
				}).catch(err => {
						console.log(err)
				})
			},
		}
	};
</script>
